export function onBlurCard(loginId, setCardError, setCardErrorMsg) {
  const numberIdNoSpace = loginId.replace(/\s/g, '');
  const parsePattern = new RegExp('^(69\\d{8}|\\d{8,12,13})$');
  const isValid = numberIdNoSpace.match(parsePattern);
  if (!isValid) {
    setCardError(true);
    setCardErrorMsg('Μη έγκυρος αριθμός κάρτας');
  } else {
    setCardError(false);
    setCardErrorMsg('');
  }
}

export function validateInput(loginId, pattern, setCardError, setCardErrorMsg, t) {
  if (!pattern) return;
  const input = loginId.replace(/\s/g, '');
  const { length, digits, letters, symbols, upperCase } = pattern;
  const digitRegex = /\d/;
  const letterRegex = /[a-zA-Z]/;
  const symbolRegex = /[!@#$%^&*(),.?":{}|<>]/;
  const upperCaseRegex = /[A-Z]/;
  if (input.length !== length) {
    setCardError(true);
    setCardErrorMsg(t('errors.loyalty_format'));
    return;
  }
  if (digits && !digitRegex.test(input)) {
    setCardError(true);
    setCardErrorMsg(t('errors.loyalty_format'));
    return;
  }
  if (letters && !letterRegex.test(input)) {
    setCardError(true);
    setCardErrorMsg(t('errors.loyalty_format'));
    return;
  }
  if (symbols && !symbolRegex.test(input)) {
    setCardError(true);
    setCardErrorMsg(t('errors.loyalty_format'));
    return;
  }
  if (upperCase && !upperCaseRegex.test(input)) {
    setCardError(true);
    setCardErrorMsg(t('errors.loyalty_format'));
    return;
  }

  setCardError(false);
  setCardErrorMsg('');
}
